import * as Yup from 'yup'

export const getIdsSchema = Yup.object().shape({
  tenantId: Yup.string()
    .required('Tenant Id required')
})
